import { createSignal, onCleanup, type JSX } from 'solid-js';
import type { OutputViewRemaining } from '../state/useOutputView';

/** This viewer's own stream: its time left, or that it is indefinite. It never names a person. */
export function outputViewIndicatorText(remaining: OutputViewRemaining, stage = false, now = Date.now()): string {
  let text = 'indefinite';
  if (remaining.kind === 'countdown') {
    const seconds = Math.max(0, Math.ceil((remaining.deadlineMs - now) / 1000));
    text = `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
  }
  return stage ? text : `Live view · ${text}`;
}

export function OutputViewIndicator(props: { remaining: OutputViewRemaining; stage?: boolean; testId?: string }): JSX.Element {
  // A once-a-second redraw; the time itself is read when drawing, so a new deadline shows its own time.
  const [tick, setTick] = createSignal(0);
  const clock = setInterval(() => setTick((count) => count + 1), 1_000);
  onCleanup(() => clearInterval(clock));
  const text = (): string => {
    tick();
    return outputViewIndicatorText(props.remaining, props.stage);
  };
  return <span class="output-view-indicator" role="status" data-testid={props.testId}>{text()}</span>;
}
